<template>
    <div>
        <form class="shaded m-5" @submit.prevent.stop="save" novalidate>
            <div class="form-group row">
                <div class="col-sm-4" :class="{ error: $v.form.name.$error }">
                    <label class="full">
                        Name
                        <span class="brand">
                            *
                        </span>
                        <input type="text" v-model="form.name" @input="$v.form.name.$touch">
                    </label>

                    <div v-if="$v.form.name.$error" class="messages">
                        <span v-if="!$v.form.name.required">Name is required.</span>
                        <span v-if="!$v.form.name.minLength">Name must have at least 3 characters.</span>
                    </div>
                </div>
                <div class="col-sm-2" v-if="getShowInvoiceOption">
                    <label class="full">
                        Cost Center
                        <input type="text" v-model="form.code">
                    </label>
                </div>
            </div>

            <div v-if="types" class="form-group row">
                <div class="col-sm-4">
                    <label class="full">Type</label>

                    <v-select
                        v-model="selectedType"
                        :options="types"
                        placeholder="- Select resource type -"
                        label="description"
                        @input="updateType">
                    </v-select>
                </div>
                <div class="col-sm-2">
                    <label class="full">
                        Max. Capacity
                        <input type="text" v-model="form.availability" v-numInt>
                    </label>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-sm-9">
                    <label class="full">
                        Description (Optional)
                        <textarea v-model="form.description"></textarea>
                    </label>
                </div>
            </div>

			<div class="mt-5">
				<h5>Resource status</h5>

				<div class="d-flex mb-3 align-items-center w-100">
					<span class="fs-small bold mr-2">Resource is active:</span>
					<toggle-button
						v-model="form.isActive"
						:labels="{checked: 'Yes', unchecked: 'No'}"
						:disabled="false"
					/>
				</div>
			</div>
        </form>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import { required, minLength, numeric } from 'vuelidate/lib/validators'

    export default {
        data: function() {
            return {
                form: {
                    name: '',
                    type: null,
                    isActive: true,
                    limited: true,
                    sharedBetweenProducts: true,
                    sharedBetweenBookings: true
                },
                selectedType: null,
            }
        },
        validations: {
            form: {
                name: {
                    required,
                    minLength: minLength(3),
                },
                availability:{
                    numeric
                }
            }
        },
        created() {
            if (!this.getCreatingNewResource) {
                if (this.getSelectedItem) {
                    this.form = JSON.parse(JSON.stringify(this.getSelectedItem));
                }
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedItem',
                'getCreatingNewResource',
                'getShowInvoiceOption'
            ]),
        },
        asyncComputed: {
            async types() {
                try {
                    let response = await axios.get('/api/settings/GetResourceTypeList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        // Map FK information through selects

                        if (this.form.type) {
                            this.selectedType = response.data.find(item => item.id === this.form.type);
                        }
                        else {
                            this.selectedType = response.data[0];
                            this.form.type = response.data[0].id;
                        }

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error.response.data.message);
                }
            }
        },
        methods: {
            updateType: function() {
                this.form.type = this.selectedType.id || null;
            },
        },
        watch: {
            $v: {
                handler: function (n, o) {
                    var toggleIsDisabled = (n.form.$invalid || n.form.$error) ? true : false;

                    this.$emit('toggleIsDisabled', toggleIsDisabled);

                    // Can we save? Have all validations been passed?
                    // Then we'll send the 'actual' form so we can
                    // set it as selectedItem

                    if (!toggleIsDisabled) {
                        this.$emit('readyToSave', this.form);
                    }
                },
                deep: true
            }
        },
        components: {
            vSelect: extendedVSelect
        }
    }
</script>



// WEBPACK FOOTER //
// ResourceForm.vue?07e8cf74